import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { store } from './store';
import { router } from './router';
import { useAuth } from './hooks';
import { tokenStorage } from './utils/tokenStorage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

function AuthInitializer({ children }: { children: React.ReactNode }) {
  const { fetchUser, isAuthenticated } = useAuth();

  useEffect(() => {
    if (tokenStorage.hasTokens() && isAuthenticated) {
      fetchUser();
    }
  }, [fetchUser, isAuthenticated]);

  return <>{children}</>;
}

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthInitializer>
          <RouterProvider router={router} />
        </AuthInitializer>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
